const temporalResolutions = {
  threeMinutes: 'Three Minutes',
  sixHourly: 'Six Hourly',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  annual: 'Annual',
  irregular: 'Irregular',
  monthlyClimatology: 'Monthly Climatology',
  threeDay: 'Three Days',
  eightDayRunning: 'Eight Day Running',
  eightDays: 'Eight Days ',
};

export default Object.freeze(temporalResolutions);
